import { observer } from 'mobx-react-lite';
import SendViewContent from './SendViewContent';
import SendViewHeader from './SendViewHeader';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  isWritting: boolean;
  sendAddress: string;
  sendAsset: string;
  trxAsset: ViewModel.IAsset | undefined;
  tokenAsset: ViewModel.IAsset | undefined;
  selectedAsset: ViewModel.IAsset | undefined;
  curculateKrw: string;
  isSendCheckBtnDisabled: boolean;
  defaultMemo: string;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickBackBtn: () => void;
  onChangeSendAddress: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAssetValue: (assetType: ViewModel.AssetType) => void;
  onClickDeleteBtn: () => void;
  onClickResetAmountBtn: () => void;
  onPaste: (text: string) => void;
  onClickSendCheckBtn: () => void;
  onClickSendCancelBtn: () => void;
  onClickCameraBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SendView = observer(
  ({
    isWritting,
    sendAddress,
    sendAsset,
    trxAsset,
    tokenAsset,
    selectedAsset,
    curculateKrw,
    isSendCheckBtnDisabled,
    defaultMemo,
    onChangeMemo,
    onClickSendCheckBtn,
    onClickSendCancelBtn,
    onPaste,
    onClickBackBtn,
    onChangeSendAddress,
    onChangeSelectedAsset,
    onChangeSelectedAssetValue,
    onClickDeleteBtn,
    onClickResetAmountBtn,
    onClickCameraBtn,
    onKeyPress,
  }: IProps) => {
    return (
      <>
        <div className="container">
          <SendViewHeader onClickBackBtn={onClickBackBtn} />
        </div>
        <SendViewContent
          defaultMemo={defaultMemo}
          isWritting={isWritting}
          sendAddress={sendAddress}
          sendAsset={sendAsset}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          selectedAsset={selectedAsset}
          curculateKrw={curculateKrw}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          onChangeMemo={onChangeMemo}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onPaste={onPaste}
          onChangeSendAddress={onChangeSendAddress}
          onChangeSelectedAsset={onChangeSelectedAsset}
          onChangeSelectedAssetValue={onChangeSelectedAssetValue}
          onClickDeleteBtn={onClickDeleteBtn}
          onClickResetAmountBtn={onClickResetAmountBtn}
          onClickCameraBtn={onClickCameraBtn}
          onKeyPress={onKeyPress}
        />
      </>
    );
  },
);

export default SendView;
